import { selectCurrentHotelName } from 'accessors'
import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import styles from './EmailEditor.module.scss'

const EmailPreview = ({ isEditable = true }) => {
  const { setEditingSection, previewHtml, handleClick, emailState } = useEmailEditor()

  const currentHotelName = useSelector(selectCurrentHotelName)

  const { subject, preheaderText } = emailState

  useEffect(() => {
    setEditingSection('inbox-preview')
  }, [setEditingSection])

  return (
    <>
      <div
        className={[
          styles.inboxPreview,
          'mjml-inbox-preview',
          isEditable ? styles.highlightedSection : ''
        ].join(' ')}
        style={{
          pointerEvents: isEditable ? 'auto' : 'none'
        }}
        onClick={handleClick}
      >
        <div>
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="5" cy="5" r="5" fill="#2563EB" />
          </svg>
        </div>
        <div className={styles.inboxText}>
          <p className={styles.hotelName}>{currentHotelName}</p>
          <p className={styles.subject}>{subject}</p>
          <p className={styles.preheader}>{preheaderText}</p>
        </div>
        <p className={styles.time}>9:41 AM</p>
      </div>
      <div
        className={styles.emailHolder}
        style={{
          pointerEvents: isEditable ? 'auto' : 'none'
        }}
      >
        <div
          className={[styles.emailWrapper, 'no-style-reset'].join(' ')}
          dangerouslySetInnerHTML={{
            __html: previewHtml
          }}
          onClick={handleClick}
        />

        {/* <iframe
        title="Email Preview"
        className={styles.emailPreviewIframe}
        srcDoc={previewHtml}
        height={800}
        width={540}
        allowTransparency={true}
        /> */}
      </div>
    </>
  )
}

export default EmailPreview
